.badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--tuna-palette-secondary-light);
  user-select: none;
  white-space: nowrap;
}

.badge[data-size='xs'] {
  /* gutter-style: icon only, no chip background, no padding */
  padding: 0;
  background: transparent;
}

.badge[data-size='sm'] {
  padding: 2px 6px;
  border-radius: var(--tuna-shape-radius-pill);
  background: var(--tuna-palette-action-hover);
  font-size: 0.6875rem; /* 11px */
  line-height: 1;
}

.badge[data-size='md'] {
  padding: 4px 8px;
  border-radius: var(--tuna-shape-radius-pill);
  background: var(--tuna-palette-action-hover);
  font-size: 0.8125rem; /* 13px */
  line-height: 1;
}

.label {
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

/* Overlay variant — used over images/audio. Card-like backdrop for legibility on any background. */
.badge[data-overlay='true'] {
  background: rgba(0, 0, 0, 0.55);
  color: var(--tuna-content-onColor);
  backdrop-filter: blur(4px);
}
